import React, { useState, useEffect } from 'react';
import {
  Box, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, Chip, Alert, CircularProgress, Grid
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getVendors, createVendor, updateVendor, deleteVendor } from '../../../services/api';

const VendorsManagement = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ vendor_code: '', name: '', contact_person: '', email: '', phone: '', tax_id: '', payment_terms: 30, address: '' });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getVendors();
      setVendors(res.data || []);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const openCreate = () => { setEditItem(null); setForm({ vendor_code: '', name: '', contact_person: '', email: '', phone: '', tax_id: '', payment_terms: 30, address: '' }); setDialogOpen(true); };
  const openEdit = (v) => { setEditItem(v); setForm({ ...v }); setDialogOpen(true); };

  const handleSave = async () => {
    try {
      if (editItem) await updateVendor(editItem.id, form);
      else await createVendor(form);
      setDialogOpen(false);
      loadData();
    } catch (err) { setError(err.message); }
  };

  return (
    <ModuleHub moduleId="accounts-payable" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={openCreate}>Add Vendor</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Name</TableCell><TableCell>Contact</TableCell><TableCell>Tax ID</TableCell><TableCell>Terms</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
            <TableBody>
              {vendors.map(v => (
                <TableRow key={v.id}>
                  <TableCell>{v.vendor_code}</TableCell>
                  <TableCell><strong>{v.name}</strong></TableCell>
                  <TableCell>{v.contact_person}<br /><small>{v.email}</small></TableCell>
                  <TableCell>{v.tax_id}</TableCell>
                  <TableCell>{v.payment_terms} days</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => openEdit(v)}><EditIcon /></IconButton>
                    <IconButton size="small" color="error" onClick={() => deleteVendor(v.id).then(loadData)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editItem ? 'Edit Vendor' : 'New Vendor'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={6}><TextField fullWidth label="Vendor Code" value={form.vendor_code} onChange={(e) => setForm({ ...form, vendor_code: e.target.value })} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Contact Person" value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Grid>
            <Grid item xs={6}><TextField fullWidth label="Tax ID (TIN/VAT)" value={form.tax_id} onChange={(e) => setForm({ ...form, tax_id: e.target.value })} /></Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={2} label="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleSave}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default VendorsManagement;
